export const Endpoint = () => `/api/v3/search/robots`;

export const QueryKey = () => ['v3', 'search', 'robots'] as const;

export type Payload = never;

export type Response = Record<string, string>;
